const CoreValues = () => {
  const livingValues = [
    {
      id: 1,
      title: 'Sống có mục đích',
      icon: '🎯',
      description: 'Định hướng rõ ràng trong cuộc sống',
    },
    {
      id: 2,
      title: 'Sống yêu thương',
      icon: '❤️',
      description: 'Lan tỏa tình yêu thương đến mọi người',
    },
    {
      id: 3,
      title: 'Sống trách nhiệm',
      icon: '🛡️',
      description: 'Chịu trách nhiệm với mọi hành động',
    },
    {
      id: 4,
      title: 'Sống bản lĩnh',
      icon: '🦁',
      description: 'Vững vàng trước mọi thử thách',
    },
    {
      id: 5,
      title: 'Sống trung thực',
      icon: '✨',
      description: 'Chân thành trong mọi quan hệ',
    },
  ];

  const actionValues = [
    {
      id: 6,
      title: 'Hành động mạnh mẽ',
      icon: '💪',
      description: 'Quyết tâm thực hiện mục tiêu',
    },
    {
      id: 7,
      title: 'Hành động quyết liệt',
      icon: '⚡',
      description: 'Thực hiện với sự quyết đoán',
    },
    {
      id: 8,
      title: 'Hành động liên tục',
      icon: '🔄',
      description: 'Kiên trì không ngừng nghỉ',
    },
    {
      id: 9,
      title: 'Hành động khôn ngoan',
      icon: '🧠',
      description: 'Suy nghĩ thấu đáo trước khi hành động',
    },
    {
      id: 10,
      title: 'Hành động bất chấp nỗi sợ hãi',
      icon: '🚀',
      description: 'Vượt qua mọi rào cản để thành công',
    },
  ];

  return (
    <section className="section-padding bg-white">
      <div className="container-custom">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            <span className="text-gradient">10 GIÁ TRỊ CỐT LÕI</span>
          </h2>
          <p className="text-xl text-primary font-semibold mb-4">
            ĐỊNH HÌNH VĂN HÓA UPOWER
          </p>
          <p className="text-lg text-gray-600 leading-relaxed">
            Những giá trị cốt lõi này là nền tảng cho mọi hoạt động và quyết
            định của chúng tôi, tạo nên văn hóa doanh nghiệp mạnh mẽ và bền
            vững.
          </p>
        </div>

        {/* Values Grid - Two Columns */}
        <div className="grid lg:grid-cols-2 gap-12 mb-12">
          {/* Living Values Column */}
          <div>
            <h3 className="text-2xl font-bold text-center text-primary mb-8">
              5 GIÁ TRỊ SỐNG
            </h3>
            <div className="space-y-6">
              {livingValues.map((value, index) => (
                <div
                  key={value.id}
                  className="group relative bg-white rounded-2xl p-6 shadow-lg border border-gray-100 hover:border-primary/30 transition-all duration-300 hover:shadow-xl hover:scale-105"
                >
                  {/* Number Badge */}
                  <div className="absolute -top-3 -right-3 w-8 h-8 bg-secondary text-gray-900 rounded-full flex items-center justify-center text-sm font-bold">
                    {value.id}
                  </div>

                  <div className="flex items-center space-x-4">
                    {/* Icon */}
                    <div className="text-4xl group-hover:scale-110 transition-transform duration-300">
                      {value.icon}
                    </div>

                    <div className="flex-1">
                      {/* Title */}
                      <h4 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-primary transition-colors duration-300">
                        {value.title}
                      </h4>

                      {/* Description */}
                      <p className="text-gray-600 text-sm leading-relaxed">
                        {value.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Action Values Column */}
          <div>
            <h3 className="text-2xl font-bold text-center text-primary mb-8">
              5 GIÁ TRỊ HÀNH ĐỘNG
            </h3>
            <div className="space-y-6">
              {actionValues.map((value, index) => (
                <div
                  key={value.id}
                  className="group relative bg-white rounded-2xl p-6 shadow-lg border border-gray-100 hover:border-primary/30 transition-all duration-300 hover:shadow-xl hover:scale-105"
                >
                  {/* Number Badge */}
                  <div className="absolute -top-3 -right-3 w-8 h-8 bg-secondary text-gray-900 rounded-full flex items-center justify-center text-sm font-bold">
                    {value.id}
                  </div>

                  <div className="flex items-center space-x-4">
                    {/* Icon */}
                    <div className="text-4xl group-hover:scale-110 transition-transform duration-300">
                      {value.icon}
                    </div>

                    <div className="flex-1">
                      {/* Title */}
                      <h4 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-primary transition-colors duration-300">
                        {value.title}
                      </h4>

                      {/* Description */}
                      <p className="text-gray-600 text-sm leading-relaxed">
                        {value.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="bg-gradient-to-r from-primary to-primary-700 rounded-2xl p-8 md:p-12 text-white text-center">
          <h3 className="text-2xl md:text-3xl font-bold mb-6">
            Sống và làm việc theo 10 giá trị cốt lõi
          </h3>
          <p className="text-lg md:text-xl text-primary-100 mb-8 max-w-3xl mx-auto leading-relaxed">
            Tại UPOWER, chúng tôi không chỉ dạy về những giá trị này mà còn sống
            và thực hành chúng mỗi ngày. Đây chính là bí quyết tạo nên sự khác
            biệt và thành công bền vững.
          </p>

          <div className="grid md:grid-cols-2 gap-6 max-w-2xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
              <h4 className="text-xl font-bold mb-3">Cho học viên</h4>
              <p className="text-primary-100">
                Áp dụng vào cuộc sống và công việc để đạt được thành công bền
                vững
              </p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
              <h4 className="text-xl font-bold mb-3">Cho doanh nghiệp</h4>
              <p className="text-primary-100">
                Xây dựng văn hóa doanh nghiệp mạnh mẽ và đội ngũ nhân viên xuất
                sắc
              </p>
            </div>
          </div>

          <button className="mt-8 bg-white text-primary font-semibold py-3 px-8 rounded-lg hover:bg-gray-100 transition-colors duration-300">
            Tìm hiểu thêm về văn hóa UPOWER
          </button>
        </div>
      </div>
    </section>
  );
};

export default CoreValues;
